import { formatDate, formatDateTime, formatDateForInput } from '../../../utils/dateUtils';

// Shared dashboard components
export { default as DashboardHeader } from './DashboardHeader';
export { default as StatCard } from './StatCard';
export { default as QuickActionButton } from './QuickActionButton';
export { default as LoadingSpinner, LoadingOverlay, InlineLoading } from './LoadingSpinner';
export { default as EmptyState } from './EmptyState';
export { formatDate, formatDateTime, formatDateForInput };

// Animation variants that can be reused across components
export const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

export const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

// Common color classes
export const colorClasses = {
  primary: 'bg-gradient-to-r from-blue-500 to-blue-600',
  green: 'bg-gradient-to-r from-green-500 to-green-600',
  orange: 'bg-gradient-to-r from-orange-500 to-orange-600',
  red: 'bg-gradient-to-r from-red-500 to-red-600',
  purple: 'bg-gradient-to-r from-purple-500 to-purple-600',
  yellow: 'bg-gradient-to-r from-yellow-500 to-yellow-600',
  gray: 'bg-gradient-to-r from-gray-500 to-gray-600'
};

// Common utility functions
export const formatCurrency = (amount, currency = 'INR') => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

export const formatRelativeTime = (date) => {
  const now = new Date();
  const inputDate = new Date(date);
  const diffInSeconds = Math.floor((now - inputDate) / 1000);
  
  if (diffInSeconds < 60) {
    return 'Just now';
  } else if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60);
    return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
  } else if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  } else if (diffInSeconds < 2592000) {
    const days = Math.floor(diffInSeconds / 86400);
    return `${days} day${days > 1 ? 's' : ''} ago`;
  } else {
    return formatDate(date);
  }
};

export const getStatusColor = (status) => {
  const statusColors = {
    pending: { bg: 'bg-yellow-100', text: 'text-yellow-800', border: 'border-yellow-200' },
    approved: { bg: 'bg-green-100', text: 'text-green-800', border: 'border-green-200' },
    rejected: { bg: 'bg-red-100', text: 'text-red-800', border: 'border-red-200' },
    draft: { bg: 'bg-gray-100', text: 'text-gray-800', border: 'border-gray-200' },
    active: { bg: 'bg-green-100', text: 'text-green-800', border: 'border-green-200' },
    inactive: { bg: 'bg-gray-100', text: 'text-gray-800', border: 'border-gray-200' },
    urgent: { bg: 'bg-red-100', text: 'text-red-800', border: 'border-red-300' },
    high: { bg: 'bg-orange-100', text: 'text-orange-800', border: 'border-orange-300' },
    medium: { bg: 'bg-yellow-100', text: 'text-yellow-800', border: 'border-yellow-300' },
    low: { bg: 'bg-green-100', text: 'text-green-800', border: 'border-green-300' }
  };
  
  return statusColors[status] || statusColors.draft;
};